import { useState } from 'react';
import axios from 'axios';

const downloadURI = (uri: string, name: string) => {
  const link = document.createElement('a');

  link.setAttribute('download', name);

  link.href = uri;
  document.body.appendChild(link);

  link.click();
  link.remove();
};

const useDownloadFile = (url: string, name: string, errorCallback?: () => void) => {
  const [progress, setProgress] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const uploadFile = async () => {
    if (!url) return;

    setIsLoading(true);
    setProgress(10);

    try {
      const res = await axios.get(url, {
        responseType: 'blob',
        onDownloadProgress: (progressEvent) => {
          const progress = Math.round(10 + (progressEvent.total ? (progressEvent.loaded / progressEvent.total) * 90 : 0));
          setProgress(progress);
        },
      });

      downloadURI(URL.createObjectURL(res.data), name);
    } catch (e) {
      setProgress(0);
      errorCallback?.();
    } finally {
      setIsLoading(false);
    }
  };

  return { uploadFile, isLoading, progress };
};

export default useDownloadFile;
